// extracted by css-extract-rspack-plugin
var _1 = "FJ4hV";
var _2 = "ywxLz";
var _3 = "Tbbce";
var _4 = "u7yLj";
var _5 = "rRhzD";
var _6 = "ILLxa";
var _7 = "BAZF4";
var _8 = "r67uW";
var _9 = "WqnPt";
var _a = "m4AX5";
var _b = "ZPL03";
var _c = "lKvAc";
var _d = "BPXEi";
var _e = "aTmgv";
var _f = "WKBCQ";
var _10 = "SW7A6";
var _11 = "YYA9V";
var _12 = "GciPK";
var _13 = "rB0Kn";
var _14 = "cR4_k";
var _15 = "Egvy6";
var _16 = "THOoJ";
var _17 = "dvm7V";
var _18 = "Yd48r";
var _19 = "kTUsm";
var _1a = "lKhXQ";
var _1b = "e8s8U";
var _1c = "nC1E4";
var _1d = "Fgjvj";
var _1e = "eiEgp";
var _1f = "c_ifE";
var _20 = "hmUtu";
var _21 = "Varvg";
var _22 = "EBbuI";
var _23 = "ffRXk";
var _24 = "qX6hl";
var _25 = "Y0SDi";
var _26 = "LN4JE";
var _27 = "r2Yc_";
var _28 = "NFjsn";
var _29 = "LyMTI";
var _2a = "PESTR";
var _2b = "G8ArK";
var _2c = "N_du_";
var _2d = "pIclM";
var _2e = "kV59c";
var _2f = "XW2m0";
var _30 = "QW7vs";
var _31 = "VvlZl";
var _32 = "C1EJK";
var _33 = "DtGia";
var _34 = "cem0l";
var _35 = "I3sS5";
var _36 = "Dt4E5";
var _37 = "SCAqn";
var _38 = "lRcJs";
var _39 = "LBktY";
var _3a = "EPX63";
var _3b = "U5nOs";
var _3c = "dbelr";
var _3d = "Mq3cC";
var _3e = "qrEcR";
var _3f = "vFxD9";
var _40 = "XmbU3";
var _41 = "wzILN";
var _42 = "N8xW_";
var _43 = "O9J_A";
var _44 = "HOVUa";
var _45 = "q9iRC";
var _46 = "LbVEN";
var _47 = "fyyXL";
var _48 = "PAPWc";
var _49 = "brBxj";
var _4a = "cdsXY";
var _4b = "LjYbv";
var _4c = "kETEC";
var _4d = "FdUPY";
var _4e = "aYnwr";
var _4f = "BoMGI";
var _50 = "_REkq";
var _51 = "PsJx7";
var _52 = "RhuSi";
var _53 = "LPfdH";
var _54 = "G8_Dc";
var _55 = "FkPdL";
var _56 = "czwRD";
var _57 = "LCprM";
var _58 = "nbmyu";
export { _1 as "allPaneContainer", _2 as "bizChatInReadingPaneStyles", _3 as "bleedthroughBackgroundDark", _4 as "bleedthroughBackgroundLight", _5 as "cardAndMLWrapper", _6 as "cardAndMLWrapperBizChatSpacing", _7 as "cardAndMLWrapperNoTopInset", _8 as "copilotSearchAnswerBackground", _9 as "denselessCompose", _a as "denselessComposeBleedthrough", _b as "denselessComposeBleedthroughNoLeftBorder", _c as "denselessComposeInnerNeutral", _d as "denselessComposeInnerNeutralLeftBorderRounded", _e as "denselessComposeInnerNoTopMargin", _f as "fullBleed", _10 as "innerPaneContent", _11 as "leftColumn", _12 as "leftColumnBleedThrough", _13 as "leftColumnDenseless", _14 as "leftColumnDenselessRtl", _15 as "leftColumnNoTopMargin", _16 as "leftColumnRtl", _17 as "leftColumnTypeRampBleedThrough", _18 as "leftPaneContainer", _19 as "leftPanelSecondRow", _1a as "leftResizeHandler", _1b as "mailListCardContainerWithRPHiddenOrBottom", _1c as "mailListCardContainerWithRPHiddenOrBottomDenseless", _1d as "mailListCardContainerWithRPHiddenOrBottomDenselessNeutral", _1e as "mailListComposeRightBorderDenseless", _1f as "mailListHide", _20 as "mailListLeftPaneVisibleFullBleed", _21 as "mailListLeftPaneVisibleFullBleedDenseless", _22 as "mailListLeftPaneVisibleFullBleedDenselessLeftBorderRounded", _23 as "mailListLeftPaneVisibleFullBleedDenselessLeftBorderRoundedRtl", _24 as "mailListLeftPaneVisibleFullBleedDenselessRightBorderRounded", _25 as "mailListLeftPaneVisibleFullBleedDenselessRightBorderRoundedRtl", _26 as "mailListNeutralBorder", _27 as "mailListNeutralBorder_Win32Style", _28 as "mailListNeutralTopBorder", _29 as "mailListRefresh", _2a as "mailListRefreshNoLeftBorder", _2b as "mailListRefreshNoLeftBorderRtl", _2c as "mailListRefreshRtl", _2d as "mailListRefresh_Win32Style", _2e as "mailListRefresh_Win32StyleEndRadius", _2f as "mailListWithRPHiddenOrBottom", _30 as "mailListWithRPHiddenOrBottomDenseless", _31 as "mailListWithRPHiddenOrBottomDenselessNeutral", _32 as "mailListWithRPRight", _33 as "mailListWithRPRightDenseless", _34 as "mailListWithRPRight_Win32Style", _35 as "mailMain", _36 as "newSearchHeaderContainer", _37 as "newSearchHeaderContainerMargin", _38 as "notificationBarHostElevated", _39 as "panes", _3a as "panesWin32Overlay", _3b as "positionRelative", _3c as "protocolNotSupportedContainer", _3d as "readingPane", _3e as "readingPane_Win32Style", _3f as "readingPane_Win32StyleBottom", _40 as "readingPane_Win32StyleNoTopMargin", _41 as "resizeHandle", _42 as "resizeHandleBottomElevated", _43 as "rightOrBottomPane_Win32Style", _44 as "rightPane", _45 as "rightPaneContainer", _46 as "rightPaneDenseless", _47 as "rightPaneWithRail", _48 as "rightPaneWithRailContent", _49 as "searchHeaderBorders", _4a as "searchHeaderBordersBleedThrough", _4b as "searchHeaderBordersBleedThroughNoBorder", _4c as "searchHeaderBordersDark", _4d as "searchHeaderBordersLight", _4e as "searchHeaderBordersNeutral", _4f as "searchHeaderLeftBordersBleedThrough", _50 as "searchNeutralLeftMargin", _51 as "searchResultsContainer", _52 as "searchResultsTabbedContainer", _53 as "searchResultsTabbedContainerDenseless", _54 as "subCommandBarPaneColumn", _55 as "subCommandBarPaneCommon", _56 as "subCommandBarPaneCommonRefresh", _57 as "subCommandBarPaneMail", _58 as "subCommandBarPaneRow" }
